import { render, staticRenderFns } from "./HistorySideBar.vue?vue&type=template&id=a1350a1a"
import script from "./HistorySideBar.vue?vue&type=script&lang=js"
export * from "./HistorySideBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports